
import moment from 'moment';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Connection, PermissionCode, User,
} from '@/types';
import EditPracticeSendingDialog from '@/components/EditPracticeSendingDialog.vue';

moment.locale('it');

@Component({
  components: {
    EditPracticeSendingDialog,
  },
})
export default class ConnectionPracticeSendDate extends Vue {
  @Prop(Object) readonly connection!: Connection;

  loading = false

  editDialog = false

  // Il valore di tipo Date memorizzato nel DB
  get practiceSendingDateValue(): Date | null { return this.connection?.practiceSendingDate ?? null; }

  get practiceSendingAnagraficaDelay(): boolean { return this.connection?.practiceSendingAnagraficaDelay === true; }

  // Se il valore memorizzato nel DB cambia...
  @Watch('practiceSendingDateValue')
  onValue() { /* agg. solo visuale */ }

  get practiceSendingDateString(): string | null {
    return this.practiceSendingDateValue
      && moment(this.practiceSendingDateValue).isValid()
      ? moment(this.practiceSendingDateValue).format('L')
      : null;
  }

  get user(): User { return this.$store.getters.currentUser; }
  get userPermissions(): PermissionCode[] { return this.$store.getters.currentUserPermissions; }
  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  get isDisabled() {
    return this.loading;
  }

  get isEditable() {
    if (!this.connection) return false;
    return this.connection
      && (this.connection.status === 'open' || this.connection.status === 'new')
      && this.hasPermission('practiceSendingDate.edit');
  }

  get columnClass(): string {
    if (this.practiceSendingDateValue) return 'green';
    if (this.practiceSendingAnagraficaDelay) return 'yellow';
    return '';
  }

  get displayText(): string {
    if (!this.practiceSendingDateString) {
      return this.practiceSendingAnagraficaDelay ? 'Disall. Anagrafica' : 'da definire';
    }
    return this.practiceSendingDateString;
  }

  get displayClass(): string {
    return this.practiceSendingDateString || this.practiceSendingAnagraficaDelay ? '' : 'grey--text text--lighten-2';
  }

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.loading || !this.isEditable) return;

    if (this.connection) {
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}

